import React from 'react';
import axios from "axios";

//
import {
  DndContext,
  closestCenter,
  KeyboardSensor,
  PointerSensor,
  TouchSensor,
  MouseSensor,
  useSensor,
  useSensors,
  DragOverlay,
} from '@dnd-kit/core';

import {
  arrayMove,
  SortableContext,
  sortableKeyboardCoordinates,
  verticalListSortingStrategy,
} from '@dnd-kit/sortable';

import {
  restrictToVerticalAxis,
  restrictToWindowEdges,
  restrictToFirstScrollableAncestor,
  restrictToParentElement
} from '@dnd-kit/modifiers';

import { SortableItem } from './SortableItem';
//

import { useLoginContext } from "../../context/loginContext";

import { Container, Grid, useMantineTheme, Box, Group, Table, ScrollArea, Text, Badge, ActionIcon, LoadingOverlay } from '@mantine/core';
import { notifications } from '@mantine/notifications';
import { IconReload, IconLoader2 } from '@tabler/icons-react';

import { BE_API_THREE, BE_API_ONE, utils, role } from "../../utils/globalVariables";
import { getPropInSubLevelRole } from "../../utils/globalFunctions";

const ColumnComp = ({ stateData, stateUtilsAllHeight, fnDragPointTouched, fnDragPointUntouched, stateId, fnSuccessSetTeknisi }) => {

  const theme = useMantineTheme();
  const mountedRef = React.useRef(true);

  const { loginContext, handleSetLoginContext } = useLoginContext();

  const notificationId = React.useRef({
    errorGetData: 'ColumnComp-1',
    errorSequenceNew: 'ColumnComp-2',
  })

  const [data, setData] = React.useState({
    refreshLoading: false,
    arrangeLoading: false
  });

  const [fag, setFag] = React.useState([]);

  React.useEffect(() => {
    setFag(stateData.projects);
  }, [stateData])

  React.useEffect(() => {
    return () => {
      // mountedRef.current = false;
    }
  }, [])

  const handleDragEnd = (event) => {
    const { active, over } = event;

    if (active.id !== over.id) {
      const oldIndex = fag.findIndex((item) => item.project_id === active.id);
      const newIndex = fag.findIndex((item) => item.project_id === over.id);

      const newSequence = arrayMove([...fag], oldIndex, newIndex);

      let resNewArr = [];

      if (Array.isArray(newSequence) && (newSequence.length > 0)) {
        resNewArr = newSequence.map((item, index) => ({
          projectId: item.project_id,
          key: index,
        }));
      }

      setFag(newSequence);

      // ! START
      setData(d => ({ ...d, arrangeLoading: true }));

      const formDT = new FormData();
      const formDTHeader = { 'Content-Type': 'application/json' }

      formDT.append('json_token', loginContext.syswebapp);
      formDT.append('sequence_new', JSON.stringify(resNewArr));

      axios({
        method: 'post',
        url: BE_API_ONE + '/set_sequence_from_dragndrop',
        data: formDT,
        headers: formDTHeader,
      }).then((response) => {
        if (!mountedRef.current) return null;

        setData(d => ({ ...d, arrangeLoading: false }));

        if (response.data.flag_status === 'isset') {
          //
        }

        if (response.data.flag_status === 'not-array') {
          //
        }

        if (response.data.flag_status === 'error') {
          setFag(fag);
        }

        if (response.data.flag_status === 'invalid-json-token') {
          handleSetLoginContext(null);
        }

        if (response.data.flag_status === 'user-inactive') {
          handleSetLoginContext(null);
        }
      }).catch(error => {
        if (!mountedRef.current) return null;

        setData(d => ({ ...d, arrangeLoading: false }));
        setFag(fag);

        notifications.show({
          id: notificationId.current.errorSequenceNew,
          title: utils.notification.warning.caption,
          message: error.message,
          color: utils.notification.warning.color,
          icon: utils.notification.warning.icon,
          withBorder: true,
          autoClose: true,
        })
      })
      // ! END
    }
  };

  const sensors = useSensors(
    useSensor(MouseSensor, {
      activationConstraint: {
        distance: 10,
      },
    }),
    useSensor(TouchSensor, {
      activationConstraint: {
        delay: 0,
        tolerance: 0,
      },
    }),
    // useSensor(PointerSensor),
    // useSensor(KeyboardSensor, {
    //   coordinateGetter: sortableKeyboardCoordinates,
    // }),
  );

  const useScrollDirectionDetector = () => {
    const prevScrollY = React.useRef(0);

    const detectScrollDirection = ({ y }) => {
      let direction = null;
      const currentScrollY = y;

      if (currentScrollY > prevScrollY.current) {
        direction = 'down';

        // if (currentScrollY >= 0) {
        document.querySelector('html').classList.remove('preventPull');
        // }
      } else if (currentScrollY < prevScrollY.current) {
        direction = 'up';

        // if (currentScrollY <= 0) {
        document.querySelector('html').classList.add('preventPull');
        // }
      }

      // Update the ref with the new scroll position for the next comparison
      prevScrollY.current = currentScrollY;

      return direction;
    };

    return detectScrollDirection;
  };

  const detectScrollDirection = useScrollDirectionDetector();

  const handleScroll = (position) => {
    const direction = detectScrollDirection(position);
    if (direction) {
      // Perform actions based on the scroll direction
    }
  };

  // Mengambil hanya ID untuk SortableContext
  const itemIds = Array.isArray(fag) && (fag.length > 0) ? fag.map(item => item.project_id) : [];

  const fnRefreshPerTeknisi = (stateId) => {
    setData(d => ({ ...d, refreshLoading: true }));

    const formDT = new FormData();
    const formDTHeader = { 'Content-Type': 'application/json' }

    formDT.append('json_token', loginContext.syswebapp);
    formDT.append('teknisi_id', stateId);

    axios({
      method: 'post',
      url: BE_API_ONE + '/get_data_prioritas_per_teknisi',
      data: formDT,
      headers: formDTHeader,
    }).then((response) => {
      if (!mountedRef.current) return null;

      setData(d => ({ ...d, refreshLoading: false }));

      if (response.data.flag_status === 'isset') {
        setFag(response.data.data)
      }

      if (response.data.flag_status === 'no-data-teknisi') {
        //
      }

      if (response.data.flag_status === 'invalid-json-token') {
        handleSetLoginContext(null);
      }

      if (response.data.flag_status === 'user-inactive') {
        handleSetLoginContext(null);
      }
    }).catch(error => {
      if (!mountedRef.current) return null;

      setData(d => ({ ...d, refreshLoading: false }));

      notifications.show({
        id: notificationId.current.errorGetData,
        title: utils.notification.warning.caption,
        message: error.message,
        color: utils.notification.warning.color,
        icon: utils.notification.warning.icon,
        withBorder: true,
        autoClose: true,
      })
    })
  }

  return (
    <div
      id={stateId + 'xxx'}
      style={{ minWidth: '300px' }}
    >
      <Box
        className='teknisiName'
        py='.65rem'
        px='sm'
        style={{
          backgroundColor: theme.colorScheme === 'light' ? theme.colors.gray[1] : theme.colors.dark[7],
          position: 'sticky',
          top: 0,
          right: 0,
          left: 0,
          borderTopLeftRadius: '5px',
          borderTopRightRadius: '5px',
        }}
      >
        <div
          style={{
            display: 'flex',
            flexWrap: 'nowrap',
            justifyContent: 'space-between',
            alignItems: 'center',
            gap: '8px'
          }}
        >
          <Text
            lineClamp={1}
            size='sm'
            fw='500'
            style={{
              wordBreak: 'break-word',
            }}
          >
            {stateData.nama}
          </Text>

          <Badge
            size='md'
            variant='light'
            styles={{
              root: {
                fontWeight: 'normal',
                letterSpacing: '0',
                cursor: 'pointer',
                backgroundColor: theme.fn.rgba(theme.colors.blue[2], 0.3),
                '&:hover': {
                  backgroundColor: theme.fn.rgba(theme.colors.blue[3], 0.3),
                }
              }
            }}

            onClick={() => fnRefreshPerTeknisi(stateData.id)}
          >
            <div
              style={{
                display: 'flex',
                flexWrap: 'nowrap',
                alignItems: 'center',
                gap: '6px',
              }}
            >
              {data.refreshLoading ? <IconLoader2 size='12px' /> : <Text size='.65rem'>{Array.isArray(fag) ? fag.length : 0}</Text>}
            </div>
          </Badge>
        </div>
      </Box>

      <ScrollArea.Autosize
        id={stateId + 'yyy'}

        scrollbarSize={16}
        offsetScrollbars={false}
        px='.35rem'
        py='.35rem'

        h={`calc(100svh - var(--mantine-header-height, 0px) - ${stateUtilsAllHeight}px - 4.5rem)`}
        mah={`calc(100svh - var(--mantine-header-height, 0px) - ${stateUtilsAllHeight}px - 4.5rem)`}

        type='hover'
        style={{
          backgroundColor: theme.colorScheme === 'light' ? theme.colors.gray[1] : theme.colors.dark[6],
          userSelect: 'none',
          // height: `calc(100svh - var(--mantine-header-height, 0px) - ${stateUtilsAllHeight}px - 4.5rem)`,
          // maxHeight: `calc(100svh - var(--mantine-header-height, 0px) - ${stateUtilsAllHeight}px - 4.5rem)`,
        }}

        onScrollPositionChange={handleScroll}
      >
        <LoadingOverlay visible={data.arrangeLoading} overlayBlur={1} />
        <DndContext
          modifiers={[restrictToVerticalAxis, restrictToFirstScrollableAncestor]}
          sensors={sensors}
          collisionDetection={closestCenter}
          onDragEnd={handleDragEnd}
        >
          <SortableContext
            items={itemIds}
            strategy={verticalListSortingStrategy}
          >
            {Array.isArray(fag) && (fag.length > 0) && fag.map((key, idx) => {
              return (
                <SortableItem
                  key={key.project_id}
                  id={key.project_id}
                  projectStep={key.project_process}
                  projectSequence={key.project_sequence}
                  name={key.customer_name}
                  barangNama={key.barang_nama}
                  barangKeluhan={key.barang_keluhan}
                  priority={key.project_priority}
                  num={idx}
                  stateData={key}

                  fnDragPointTouched={(e) => fnDragPointTouched(e)}
                  fnDragPointUntouched={(e) => fnDragPointUntouched(e)}
                  fnSuccessSetTeknisi={fnSuccessSetTeknisi}
                />
              )
            })}
          </SortableContext>
        </DndContext>

        <Text
          size='xs'
          mb='.25rem'
          c='dimmed'
          style={{
            textAlign: 'center'
          }}
        >
          No More Projects
        </Text>
      </ScrollArea.Autosize>
    </div>
  )
}

export default ColumnComp;